import { coinList } from '@/constants'
import { Box, HStack, Image, Text } from '@chakra-ui/react'
import { AddressWithCopy } from './shared'

export const PriceFeedItem = ({ item }) => {
  return (
    <Box
      borderWidth="1px"
      borderRadius="lg"
      overflow="hidden"
      p={4}
      mb={4}
      display="flex"
      flexDirection="column"
    >
      <HStack gap={1}>
        <Text>
          <strong>Price Feed:</strong>
        </Text>

        <HStack gap={1}>
          {coinList[item.key] && (
            <Image w={6} src={coinList[item.key]} alt={item.pair} />
          )}

          <Text>{item.pair}</Text>
        </HStack>
      </HStack>
      <Text>
        <strong>Latest Price:</strong> {item.latestAnswer} {item.symbol}
      </Text>
      <Text>
        <strong>Last updated At:</strong> {item.updatedAt}
      </Text>
      <HStack>
        <strong>Contract Address:</strong>{' '}
        <AddressWithCopy symbols={8} address={item.contract} />
      </HStack>
    </Box>
  )
}
